module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DModal', {
    attrs: {
      "show-close": false,
      "isBgOverlay": true,
      "placeInTop": true
    },
    on: {
      "close": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "d-modal",
    attrs: {
      "slot": "insertComponent",
      "id": "d-create-task-for-user"
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "d-modal__header"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('vue2.create_activity.create_activity_for')) + " " + _vm._s(_vm.user.name))])]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__content"
  }, [_c('div', {
    staticClass: "d-group"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v(_vm._s(_vm.$t('vue2.create_activity.title')))]), _vm._v(" "), _c('div', {
    staticClass: "choose-subject"
  }, [_c('dSelect', {
    attrs: {
      "items": _vm.sortedSubjects,
      "receiveData": _vm.theNewSubject,
      "multiple": false,
      "placeholder": _vm.$t('vue2.create_activity.search_or_create'),
      "itemSpaceBetween": true
    },
    on: {
      "enter": _vm.onCreateNewSubject,
      "update": _vm.setSubject,
      "searchText": _vm.setTheSearchText,
      "onSearchTextDebounced": _vm.onSearchTextDebounced,
      "close": _vm.onCloseDSelect
    },
    scopedSlots: _vm._u([_vm._l((_vm.sortedSubjects), function(item, index) {
      return {
        key: "test",
        fn: function(slotProps) {
          return [_c('div', {
            staticClass: "choose-subject__event_type"
          }, [_vm._v("\n                " + _vm._s(slotProps.item.vSubjectType) + "\n              ")])]
        }
      }
    })], null, true)
  }, [_vm._v(" "), _c('div', {
    attrs: {
      "slot": "noMatch"
    },
    slot: "noMatch"
  }, [_c('h4', {
    staticClass: "create-subject-link",
    on: {
      "click": _vm.onCreateNewSubject
    }
  }, [_vm._v("\n                + " + _vm._s(_vm.$t('vue2.substitution.create')) + ": \"" + _vm._s(_vm.theSearchText) + "\"\n              ")])])]), _vm._v(" "), (_vm.isShowCreateSubjectButton) ? _c('div', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        arrow: true,
        animateFill: false,
        animation: 'shift-away',
        zIndex: '999999992',
        boundary: 'window'
      }),
      expression: "{\n              arrow: true,\n              animateFill: false,\n              animation : 'shift-away',\n              zIndex: '999999992',\n              boundary: 'window'\n            }"
    }],
    staticClass: "icon__bg-circle create-new-subject",
    attrs: {
      "content": _vm.$t("vue2.substitution.create") + " \"" + _vm.theSearchText + "\" "
    },
    on: {
      "click": _vm.onCreateNewSubject
    }
  }, [_c('span', {
    staticClass: "d-icon-plus"
  })]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "d-group"
  }, [_c('div', {
    staticClass: "time-changer__group"
  }, [_c('TimeChanger', {
    attrs: {
      "showIcon": true,
      "start": _vm.startTime,
      "end": _vm.endTime,
      "isFiveMinutesInterval": false
    },
    on: {
      "updateStart": _vm.setStartTime,
      "updateEnd": _vm.setEndTime
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "d-group"
  }, [_c('DateSelector', {
    attrs: {
      "date": _vm.date
    },
    on: {
      "changed": _vm.setDate
    }
  })], 1), _vm._v(" "), (_vm.showSubstituteOption) ? _c('div', {
    staticClass: "d-group"
  }, [_c('div', {
    staticClass: "set-as-substitute",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.isSetAsSubstitute = !_vm.isSetAsSubstitute
      }
    }
  }, [_c('AppToggle', {
    attrs: {
      "propOn": _vm.isSetAsSubstitute,
      "allowChanges": false
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "d-label set-as-substitute__label"
  }, [_vm._v(_vm._s(_vm.$t('vue2.create_activity.set_as_substitute')))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        arrow: true,
        animateFill: false,
        animation: 'shift-away',
        boundary: 'window',
        placement: 'top',
        zIndex: '999999992'
      }),
      expression: "{\n                  arrow: true,\n                  animateFill: false,\n                  animation: 'shift-away',\n                  boundary: 'window',\n                  placement: 'top',\n                  zIndex: '999999992'\n                }"
    }],
    staticClass: "set-as-substitute__help",
    attrs: {
      "content": _vm.$t('vue2.create_activity.set_as_substitute_help')
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('span', {
    staticClass: "icon-question3 d-label__help"
  })])], 1)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__buttons pad-1"
  }, [_c('button', {
    staticClass: "do-bttn",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')))]), _vm._v(" "), (!_vm.isValidated) ? _c('button', {
    staticClass: "do-bttn do-bttn--submit do-bttn--submit--disabled"
  }, [_vm._v(_vm._s(_vm.$t('vue2.common.save')) + "\n      ")]) : _c('button', {
    staticClass: "do-bttn do-bttn--submit",
    class: {
      'do-bttn--submit--loading': _vm.isSubmitting
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.common.save')) + "\n      ")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-275da70c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CreateTask/CreateTaskForm.vue
// module id = 1816
// module chunks = 1